import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const Title = styled.h1``;

export const Description = styled.p``;